import { FieldValues } from "react-hook-form";

import { I18nKeyType } from "@/i18n";

import { BaseFormInputPropsType, VnFormInput } from "../VnForm";
import { BaseTextInput, BaseTextInputPropsType } from "./BaseTextInput";

export type VnTextInputPropsType<T extends FieldValues> =
  BaseFormInputPropsType<T> &
    Omit<BaseTextInputPropsType, "onChange"> & {
      placeholderI18nKey?: I18nKeyType;
      placeholderI18nOptions?: object;
      inputClassName?: string;
      onTextCleared?: () => void;
      preventEditing?: boolean;
    };

export const VnTextInput = <T extends FieldValues>({
  placeholderI18nKey,
  placeholderI18nOptions,
  inputClassName,
  onTextCleared,
  preventEditing,
  ...props
}: VnTextInputPropsType<T>) => {
  return (
    <VnFormInput {...props}>
      {({ field, hasError }) => {
        const handleChangeText = (text: string) => {
          if (preventEditing) return;
          if (text === "" && onTextCleared) {
            onTextCleared();
          }
          field.onChange(text);
        };

        const handleBlur = () => {
          field.onBlur();
        };

        return (
          <BaseTextInput
            i18nKey={placeholderI18nKey}
            i18nOptions={placeholderI18nOptions}
            className={inputClassName}
            editable={!props.isDisabled}
            hasError={hasError}
            value={field.value}
            onChangeText={handleChangeText}
            onBlur={handleBlur}
            {...props}
          />
        );
      }}
    </VnFormInput>
  );
};
